import { useEffect } from "react";
import { Typography, Row, Col } from "antd";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAllAdmins } from "../../redux/actions/mainAction";

const AdminsComponent = () => {
  const dispatch = useDispatch();
  const { GlobalResponse } = useSelector((state) => state);

  const location = useLocation();
  const { MainResponse } = useSelector((state) => state);

  useEffect(() => {
    getAdmins();
  }, [GlobalResponse.triggeranyevent]);

  const getAdmins = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-admins/`,
        {
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      const result = await response.json();
      console.log(result);
      dispatch(setAllAdmins(result));
    } catch (error) {
      console.log(error);
    }
  };

  const emptyAdmins = () => (
    <div className="admin-container">
      <Row>
        <Col span={24}>
          <Typography.Text className="title-admin">
            Admin əlavə edilməyib
          </Typography.Text>
        </Col>
      </Row>
    </div>
  );

  const renderAdmins = (admins) => (
    <div
      key={admins._id}
      className="admin-container"
      style={{ flex: "0 0 19.5%" }}
    >
      <Row>
        <Col span={24}>
          <Typography.Text className="title-admin">
            {admins.employeeName}
          </Typography.Text>
        </Col>
      </Row>
    </div>
  );

  var visibleAdmins =
    location.pathname === "/" && MainResponse.allAdmins.length > 0
      ? MainResponse.allAdmins
          .filter((admin) => admin.appRole === "Admin")
          .slice(0, 5)
      : MainResponse.allAdmins; // Limit to 6 items

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {MainResponse.allAdmins.length > 0
        ? visibleAdmins
            .filter((admin) => admin.appRole === "Admin")
            .map((admin) => renderAdmins(admin))
        : emptyAdmins()}
    </div>
  );
};

export default AdminsComponent;
